import compareAsc from 'date-fns/compareAsc';
import compareDesc from 'date-fns/compareDesc';
import { getMaxDate } from './getMaxDate';
import { getNextWeekDay } from './getNextWeekDay';
import { getWeeksAdded } from './getWeeksAdded';

export function getNextBusinessDayInRange(
  date = new Date(),
  options = {
    minDate: null,
    maxDate: null,
  }
) {
  const DEFAULT_WEEKS = 3;
  const DEFAULT_YEARS = 2;
  const minValidDate =
    options?.minDate ?? getWeeksAdded(new Date(), DEFAULT_WEEKS);
  const maxValidDate =
    options?.maxDate ?? getMaxDate(new Date(), { years: DEFAULT_YEARS });
  const afterThanMaxDate = compareAsc(date, maxValidDate) > 0;
  const beforeThanMinDate = compareDesc(date, minValidDate) > 0;

  if (afterThanMaxDate) {
    return getNextWeekDay(maxValidDate);
  }

  if (beforeThanMinDate) {
    return getNextWeekDay(minValidDate);
  }

  return getNextWeekDay(date);
}
